import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const ErrorPage = ({ errorCode }) => {
  const getErrorMessage = (code) => {
    switch (code) {
      case 404:
        return "Page not found.";
      case 500:
        return "Internal server error.";
      case 403:
        return "Forbidden.";
      case 401:
        return "Unauthorized.";
      default:
        return "An unexpected error occurred.";
    }
  };

  return (
    <section>
      <Container fluid>
        <Row>
          <Col xs={12} className="d-flex flex-column justify-content-center align-items-center">
            <h1 className='headerText headerTextHighlight'>Oops!</h1>
            <h1 className='headerText headerTextHighlight'>{getErrorMessage(errorCode)}</h1>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ErrorPage;